import { CircularProgress, Typography } from '@mui/material';

const ProcessingPopup = () => {
  return (
    <div
      className="box-border text-center p-10"
      style={{ maxWidth: '380', backgroundColor: '#141416' }}
    >
      <CircularProgress sx={{ color: '#C685F9', fontSize: 30}} thickness={5} />
      <Typography variant="h3" className="my-4">
        Processing!
      </Typography>
      <Typography className="mt-4">
        It may take some minutes to complete the transaction.
      </Typography>
    </div>
  );
};

export default ProcessingPopup;
